module.exports = __webpack_public_path__ + "static/media/beetzmax-5.1c79eb57.jpg";